import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getUsuarios() {
  console.log("Usuarios")
    const UsuariosDB =  [];
    const collectionRef = collection(db, "Usuarios/".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      UsuariosDB.push(doc.data());
    });
    return UsuariosDB;
}

